export class Maintenance {
    id:number;
    name:string;
    birthdate:string;
    gender:string;
    location:string;
}